import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../components-v2/Theme/theme';
import { DefaultBorder } from '../../styles/styles';

const { colors, spacing, common } = THEME;

export const styleSheet = StyleSheet.create({
	authorInput: {
		backgroundColor: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		boxSizing: 'border-box',
		fontSize: 13,
		padding: spacing.sm,
		width: '100%',
		minHeight: 32,
		maxHeight: 32,
		[THEME.queries.md]: {
			fontSize: 16,
			padding: 12,
			minHeight: 44,
			maxHeight: 44,
		},
	},
	charCount: {
		color: colors.text.dark,
		fontSize: 12,
		[THEME.queries.md]: {
			fontSize: 13,
			fontWeight: 500,
		},
	},
	charCountError: {
		color: colors.danger.main,
		fontWeight: 600,
	},
	checkbox: {
		marginRight: spacing.sm,
	},
	checkboxGrid: {
		display: 'grid',
		gap: spacing.sm,
		gridTemplateColumns: '1fr 1fr',
		marginBottom: spacing.md,
		[THEME.queries.xs]: {
			gridTemplateColumns: '1fr',
			gap: spacing.xs,
		},
	},
	checkboxLabel: {
		alignItems: 'center',
		color: colors.text.light,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 13,
		padding: '4px 0',
		[THEME.queries.md]: {
			fontSize: 14,
			padding: '8px 0',
		},
	},
	colorPicker: {
		background: colors.background.light,
		border: 'none',
		borderRadius: common.borderRadius,
		cursor: 'pointer',
		gridArea: 'overlay',
		height: spacing.xl,
		padding: 0,
		width: '100%',
	},
	colorPickerGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	colorPickersContainer: {
		display: 'flex',
		gap: 12,
		marginBottom: 16,
		[THEME.queries.xs]: {
			flexDirection: 'column',
			gap: 8,
		},
	},
	colorPickerWrapper: {
		display: 'grid',
		gridTemplateAreas: '"overlay"',
		placeItems: 'baseline',
		position: 'relative',
		width: '100%',
	},
	controlsPane: {
		backgroundColor: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		maxHeight: '100%',
		overflowY: 'hidden',
		padding: 40,
		width: 500,
		flexShrink: 1,
		minWidth: 380,
		[THEME.queries.lg]: {
			width: '100%',
			maxWidth: 640,
			maxHeight: 'none',
			minWidth: 0,
			order: 1,
			margin: '0 auto',
		},
		[THEME.queries.md]: {
			maxWidth: 'calc(100vw - 32px)',
			padding: spacing.md,
		},
		[THEME.queries.compactHeight]: {
			padding: 20,
		},
	},
	description: {
		color: colors.text.light,
		fontFamily: 'Sora',
		fontSize: 12,
		fontWeight: 400,
		marginBottom: spacing.md,
		textAlign: 'left',
	},
	editorContainer: {
		alignItems: 'flex-start',
		backgroundColor: colors.background.main,
		boxSizing: 'border-box',
		display: 'flex',
		gap: spacing.xl,
		height: '100%',
		justifyContent: 'center',
		padding: spacing.md,
		width: '100%',
		overflow: 'auto',
		[THEME.queries.lg]: {
			alignItems: 'center',
			flexDirection: 'column',
			gap: spacing.md,
			height: 'auto',
			maxWidth: '100vw',
			overflow: 'visible',
			padding: spacing.md,
		},
		[THEME.queries.md]: {
			gap: spacing.sm,
		},
	},
	errorIndicator: {
		alignItems: 'center',
		backgroundColor: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		marginTop: spacing.md,
		padding: spacing.md,
		width: '100%',
	},
	errorMessage: {
		color: colors.danger.main,
		fontSize: 16,
		textAlign: 'center',
	},
	fieldRow: {
		display: 'flex',
		gap: 16,
		alignItems: 'flex-start',
		[THEME.queries.xs]: {
			flexDirection: 'column',
			gap: 8,
		},
	},
	fieldRowGrow: {
		flex: 1,
		minWidth: 0,
	},
	fieldRowFontSize: {
		width: 132,
		[THEME.queries.xs]: {
			width: '100%',
		},
	},
	formGroup: {
		marginBottom: spacing.sm,
		[THEME.queries.compactHeight]: {
			marginBottom: `${spacing.sm / 2}px`,
		},
	},
	generateButton: {
		fontSize: 14,
		width: '100%',
		marginTop: spacing.md,
		[THEME.queries.md]: {
			fontSize: 16,
			padding: '12px 16px',
			marginTop: spacing.sm,
		},
		[THEME.queries.compactHeight]: {
			marginTop: 0,
		},
	},
	hexValue: {
		color: colors.text.dark,
		fontSize: 12,
		fontWeight: 'bold',
		gridArea: 'overlay',
		pointerEvents: 'none',
		transform: 'translate(8px, -8px)',
		zIndex: 1,
	},
	label: {
		color: colors.text.light,
		fontSize: 13,
		fontWeight: 500,
		[THEME.queries.md]: {
			fontSize: 14,
			fontWeight: 600,
		},
	},
	labelContainer: {
		alignItems: 'flex-end',
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: 4,
	},
	optionsSection: {
		marginBottom: 0,
		marginTop: spacing.sm,
		[THEME.queries.md]: {
			marginTop: spacing.md,
			marginBottom: spacing.xs,
		},
		[THEME.queries.compactHeight]: {
			marginTop: `${spacing.sm / 2}px`,
		},
	},
	previewContainer: {
		display: 'flex',
		overflow: 'hidden',
		position: 'relative',
		width: '100%',
	},
	previewFrame: {
		border: 'none',
		borderRadius: common.borderRadius,
		display: 'block',
		left: 0,
		position: 'absolute',
		top: 0,
		transformOrigin: 'top left',
	},
	previewMessage: {
		color: colors.text.light,
		margin: '0 auto',
	},
	saveDefaultsRow: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingTop: 16,
	},
	summarizeRow: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 8,
		paddingTop: 8,
	},
	createBlockedHint: {
		color: colors.text.light,
		display: 'block',
		fontSize: 12,
		paddingTop: 4,
		textAlign: 'center',
	},
	layoutBox: {
		border: `1px dashed ${colors.border.main}`,
		boxSizing: 'border-box',
		cursor: 'move',
		position: 'absolute',
		touchAction: 'none',
		zIndex: 1,
		':hover': {
			borderColor: colors.primary.main,
		},
	},
	layoutBoxSelected: {
		border: `2px dashed ${colors.primary.main}`,
		zIndex: 2,
	},
	layoutBoxLabel: {
		backgroundColor: colors.primary.main,
		borderRadius: common.borderRadius,
		color: colors.primary.contrastText,
		fontSize: 10,
		left: 0,
		lineHeight: 1,
		padding: 4,
		pointerEvents: 'none',
		position: 'absolute',
		top: -16,
		whiteSpace: 'nowrap',
	},
	layoutBoxEditor: {
		backgroundColor: 'transparent',
		border: 'none',
		boxSizing: 'border-box',
		fontFamily: "'Sora', sans-serif",
		fontWeight: 600,
		hyphens: 'none',
		left: 0,
		lineHeight: 1.4,
		outline: 'none',
		overflow: 'hidden',
		overflowWrap: 'anywhere',
		padding: 0,
		position: 'absolute',
		resize: 'none',
		top: 0,
		transformOrigin: 'top left',
		wordBreak: 'break-word',
	},
	layoutBoxHandle: {
		backgroundColor: colors.background.light,
		border: `2px solid ${colors.primary.main}`,
		borderRadius: '50%',
		height: 12,
		position: 'absolute',
		touchAction: 'none',
		width: 12,
	},
	layoutBoxHandle_nw: { left: -6, top: -6, cursor: 'nwse-resize' },
	layoutBoxHandle_n: { left: 'calc(50% - 6px)', top: -6, cursor: 'ns-resize' },
	layoutBoxHandle_ne: { right: -6, top: -6, cursor: 'nesw-resize' },
	layoutBoxHandle_e: { right: -6, top: 'calc(50% - 6px)', cursor: 'ew-resize' },
	layoutBoxHandle_se: { right: -6, bottom: -6, cursor: 'nwse-resize' },
	layoutBoxHandle_s: { left: 'calc(50% - 6px)', bottom: -6, cursor: 'ns-resize' },
	layoutBoxHandle_sw: { left: -6, bottom: -6, cursor: 'nesw-resize' },
	layoutBoxHandle_w: { left: -6, top: 'calc(50% - 6px)', cursor: 'ew-resize' },
	previewContent: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
	},
	controlsContent: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
	},
	controlsFooter: {
		borderTop: DefaultBorder,
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		marginTop: 16,
		paddingTop: 16,
	},
	previewPane: {
		alignItems: 'stretch',
		backgroundColor: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		display: 'flex',
		flex: '1',
		flexDirection: 'column',
		maxHeight: '100%',
		maxWidth: 720,
		overflowY: 'hidden',
		overflowX: 'hidden',
		padding: 40,
		minWidth: 420,
		[THEME.queries.lg]: {
			flex: '0 0 auto',
			width: '100%',
			maxWidth: 640,
			maxHeight: 'none',
			minWidth: 0,
			order: 2,
			margin: '0 auto',
		},
		[THEME.queries.md]: {
			maxWidth: 'calc(100vw - 32px)',
			padding: spacing.md,
		},
		[THEME.queries.compactHeight]: {
			padding: 20,
		},
	},
	previewWrapper: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		justifyContent: 'center',
		minHeight: 0,
		width: '100%',
	},
	subtitle: {
		color: colors.text.main,
		fontSize: 16,
		fontWeight: 600,
		margin: 0,
		textAlign: 'left',
		[THEME.queries.md]: {
			fontSize: 18,
			marginBottom: spacing.xs,
		},
	},
	textarea: {
		backgroundColor: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		fontSize: 13,
		minHeight: 100,
		padding: 8,
		resize: 'vertical',
		width: '100%',
		boxSizing: 'border-box',
		[THEME.queries.md]: {
			fontSize: 16,
			minHeight: 80,
			padding: 12,
		},
	},
	textareaError: {
		borderColor: colors.danger.main,
	},
	warningMessage: {
		color: colors.warning.main,
		fontSize: 12,
		marginTop: 4,
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 8,
	},
	postFrom: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		alignItems: 'center',
	},
	userDropdown: {
		flex: 1,
		maxWidth: 150,
	},
	backgroundImageContainer: {
		display: 'flex',
		gap: spacing.md,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	addBackgroundImageButton: {
		paddingLeft: 0,
	},
	backgroundImagePreviewContainer: {
		display: 'flex',
		gap: spacing.md,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	backgroundImagePreview: {
		height: 100,
		width: 100,
		objectFit: 'cover',
		borderRadius: common.borderRadius,
	},
	creationDialog: {
		maxWidth: 400,
	},
	creationDialogBody: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
		paddingBottom: SPACE[16],
		paddingTop: SPACE[16],
		textAlign: 'center',
	},
	creationDialogStep: {
		color: colors.text.dark,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	creationDialogTitle: {
		margin: 0,
	},
	summarizeError: {
		color: colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
});

export const getDynamicStyles = (bgColor: string, textColor: string) => ({
	'--dynamic-bg-color': bgColor,
	'--dynamic-text-color': textColor,
});
